export const COLOR_MODE_COOKIE_KEY = 'color-mode'
export type ColorModeValue = 'light' | 'dark'
